import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Building2, Plus, Trash2, Eye, RefreshCw, Settings } from 'lucide-react';

export function CommunitiesList({ communities, onView, onDelete, onCreate, onRefresh, onConfigure }) {
  return (
    <Card className="bg-gk-navy-light/40 border-gk-teal/20 backdrop-blur-sm">
      <CardHeader className="border-b border-gk-teal/30">
        <div className="flex items-center justify-between">
          <CardTitle className="text-white flex items-center gap-2">
            <Building2 className="w-5 h-5 text-slate-400" />
            Communities
          </CardTitle>
          <div className="flex gap-2">
            <Button onClick={onRefresh} variant="outline" size="sm" className="border-gk-teal/50 text-slate-300 hover:bg-gk-navy-hl">
              <RefreshCw className="w-4 h-4 mr-1" />
              Refresh
            </Button>
            <Button onClick={onCreate} className="bg-gk-teal hover:bg-gk-teal-hover" size="sm">
              <Plus className="w-4 h-4 mr-1" />
              New Community
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-6">
        {communities.length === 0 ? (
          <div className="text-center py-12">
            <Building2 className="w-16 h-16 text-gk-teal/50 mx-auto mb-4" />
            <p className="text-slate-300">No communities yet</p>
            <p className="text-sm text-slate-400 mt-2">Create your first community to get started</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {communities.map((community) => (
              <Card key={community.id} className="bg-slate-800/50 border-gk-teal/20 hover:border-gk-teal/50 transition-all">
                <CardContent className="p-4">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h3 className="font-semibold text-white">{community.name}</h3>
                      <p className="text-xs text-slate-300 truncate max-w-[180px]">{community.address}</p>
                    </div>
                    <Badge className="bg-gk-teal">{community.max_guards} guards max</Badge>
                  </div>
                  <div className="grid grid-cols-3 gap-2 mb-4">
                    <div className="text-center p-2 bg-gk-navy/50 rounded">
                      <p className="text-lg font-bold text-emerald-400">{community.user_counts?.residents || 0}</p>
                      <p className="text-xs text-slate-400">Residents</p>
                    </div>
                    <div className="text-center p-2 bg-gk-navy/50 rounded">
                      <p className="text-lg font-bold text-amber-400">{community.user_counts?.guards || 0}</p>
                      <p className="text-xs text-slate-400">Guards</p>
                    </div>
                    <div className="text-center p-2 bg-gk-navy/50 rounded">
                      <p className="text-lg font-bold text-blue-400">{community.user_counts?.management || 0}</p>
                      <p className="text-xs text-slate-400">Mgmt</p>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Button onClick={() => onView(community)} variant="outline" size="sm" className="flex-1 border-gk-teal/50 text-slate-300 hover:bg-gk-navy-hl">
                      <Eye className="w-4 h-4 mr-1" />
                      View
                    </Button>
                    <Button data-testid={`configure-community-${community.id}`} onClick={() => onConfigure(community)} variant="outline" size="sm" className="flex-1 border-amber-500/50 text-amber-300 hover:bg-amber-600/20">
                      <Settings className="w-4 h-4 mr-1" />
                      Configure
                    </Button>
                    <Button onClick={() => onDelete(community.id, community.name)} variant="outline" size="sm" className="border-red-500/50 text-red-400 hover:bg-red-600/30">
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
